import React from "react";
import { Button, CloseIcon, DatePicker } from "@pd/pd-ui-kit";
import { Control, Controller } from "react-hook-form";

import Input from "~/shared/ui/Fields/Input";
import { Select } from "~/shared/ui/Select";

import { defaultValueActsFilterIProps, EVENT_TYPE_OPTIONS } from "./options";

import s from "./HistoryActsFilter.less";

interface HistoryActsFormIProps {
  onSubmit: () => void;
  control: Control<defaultValueActsFilterIProps>;
  resetFilter: () => void;
  closeModal: () => void;
}

const HistoryActsForm = ({
  onSubmit,
  control,
  resetFilter,
  closeModal,
}: HistoryActsFormIProps) => {
  return (
    <form className={s.formFilter} onSubmit={onSubmit}>
      <div className={s.wrapperFields}>
        <div className={s.twoFieldsLine}>
          <div className={s.item}>
            <span className={s.titleField}>Название акта</span>
            <Input
              customClassName={s.newStyleInput}
              name="fileName"
              control={control}
            />
          </div>
          <div className={s.item}>
            <span className={s.titleField}>Пользователь</span>
            <Input
              customClassName={s.newStyleInput}
              name="userName"
              control={control}
            />
          </div>
        </div>

        <div className={s.twoFieldsLine}>
          <div className={s.item}>
            <span className={s.titleField}>Тип события</span>
            <Controller
              name={"action"}
              control={control}
              render={({ onChange, value }) => (
                <Select
                  placeholder="Выберите"
                  labelInValue
                  onChange={onChange}
                  value={value}
                  options={EVENT_TYPE_OPTIONS}
                  style={{ width: "100%" }}
                />
              )}
            />
          </div>
          <div className={s.item}>
            <span className={s.titleField}>Период</span>
            <div className={s.rangeWrapp}>
              <Controller
                control={control}
                name="dateFrom"
                render={({ onChange, value, onBlur }) => (
                  <DatePicker
                    placeholder="от дд.мм.гггг"
                    format="DD.MM.YYYY"
                    value={value}
                    onBlur={onBlur}
                    onChange={(date: Date) => onChange(date)}
                  />
                )}
              />
              <span>-</span>
              <Controller
                control={control}
                name="dateTo"
                render={({ onChange, value, onBlur }) => (
                  <DatePicker
                    placeholder="до дд.мм.гггг"
                    format="DD.MM.YYYY"
                    value={value}
                    onBlur={onBlur}
                    onChange={(date: Date) => onChange(date)}
                  />
                )}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={s.reset}>
        <div className={s.resetClicker} onClick={resetFilter}>
          <span>Очистить все фильтры</span>
          <CloseIcon fill="#E37639" size={16} />
        </div>
      </div>

      <div className={s.buttonGroup}>
        <Button
          fontSize="14"
          size="middle"
          htmlType="button"
          onClick={closeModal}
        >
          Отмена
        </Button>
        <Button fontSize="14" size="middle" color="secondary" htmlType="submit">
          Применить
        </Button>
      </div>
    </form>
  );
};

export default HistoryActsForm;
